import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { AbstractFeatureEntityStore } from '@y42/feature';
import { OrchestrationGitFactoryService } from './orchestration-git-factory.service';
import { OrchestrationState } from './orchestration.model';

const initialState: OrchestrationState = {
  loading: true,
  last_used: {},
  starred: {},
  active: null,
  ui: {},
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'orchestration', idKey: '$path' })
export class OrchestrationStore extends AbstractFeatureEntityStore<OrchestrationState> {
  constructor(protected readonly gitFactory: OrchestrationGitFactoryService) {
    super({
      name: 'Orchestration',
      gitFactory,
      initialState,
    });
  }
}
